import React from 'react';
import { BasePortComponent, BasePortProps } from '@jsplumbtoolkit/browser-ui-react';

import { classnames } from 'lib/classnames';

import styles from './index.module.less';

const cx = classnames(styles);
interface PortProps {
  key: string;
  type: string;
  node: any;
}

class Port extends BasePortComponent<PortProps & BasePortProps, Record<string, never>> {
  constructor(props: PortProps & BasePortProps) {
    super(props);
  }

  render(): React.ReactElement {
    const direction = this.props.type.toLocaleLowerCase();
    return (
      <div id={`${this.props.node.id}_${this.props.type}_wrapper`} className={cx('node-point-wrapper', direction)}>
        <div
          id={`${this.props.node.id}_${this.props.type}`}
          className={cx('node-point')}
          data-jtk-port-type={this.props.type}
          data-jtk-port={`${this.props.node.id}_${this.props.type}`}
          data-jtk-source
          data-jtk-target
          data-jtk-endpoint
        />
      </div>
    );
  }
}

export default Port;
